import Cookies from 'browser-cookies';

import { helpCenterActions } from '@sv-support-sdk/store';
import { tableRender } from '@sv-support-sdk/utils/src/helpers/table';
import { iframeRender } from '@sv-support-sdk/utils/src/helpers/iframe';
import { templateRender } from '@sv-support-sdk/utils/src/helpers/templates';
import { IHelpCenterTopic } from '@sv-support-sdk/shared-types/src/common/helpCenter'

import { helpCenterActions as helpCenterActionsSlices } from '../slices/helpCenter';

import { HOUR_IN_MILLISECONDS, SUPPORT_CES_TOPICS } from '../../constants/customerEffort';
import { ISendTopicCESData } from '../../api/modules/customerEffort';
import { TThunk } from '../index';
import { $l } from '../../locales';

export default {
  ...helpCenterActionsSlices,
  ...helpCenterActions,
};

export const getTopics = (): TThunk => async (dispatch, getState, api) => {
  const {
    helpCenter: { topics, loading },
  } = getState();

  if (loading.topics || Object.keys(topics).length) return;

  try {
    dispatch(helpCenterActionsSlices.setTopicsLoading(true));

    const { data } = await api.helpCenter.getTopics();

    const res = data.reduce((acc: { [key: string]: IHelpCenterTopic[] }, el: IHelpCenterTopic) => {
      const topic: IHelpCenterTopic = {
        ...el,
        description: iframeRender(
          tableRender(
            templateRender(el.description, {
              noteTitle: $l('HELP_CENTER_TOPIC.NOTE'),
              tipTitle: $l('HELP_CENTER_TOPIC.TIP'),
            }),
          ),
        ),
      };
      const category = acc[topic.categorySlug];

      acc[topic.categorySlug] = category ? [...category, topic] : [topic];

      return acc;
    }, {});

    dispatch(helpCenterActionsSlices.setTopics(res));
  } finally {
    dispatch(helpCenterActionsSlices.setTopicsLoading(false));
  }
};

interface ISendCESParams {
  slug: string;
  data: ISendTopicCESData;
}

export const rateFeedback = ({ slug, data }: ISendCESParams): TThunk => async (dispatch, getState, api) => {
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + HOUR_IN_MILLISECONDS);

  await api.customerEffort.sendTopicCES(slug, data);

  Cookies.set(
    `${SUPPORT_CES_TOPICS}-${slug}`,
    `${data.score}`,
    {
      expires: expirationDate.toUTCString(),
    },
  );
};
